import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";
import { Header } from "./components/layout/Header";
import { Footer } from "./components/layout/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { Home } from "./pages/Home";
import { Sour } from "./pages/Sour";
import { Sweet } from "./pages/Sweet";
import { Gallery } from "./pages/Gallery";
import { Contact } from "./pages/Contact";
import { Datenschutz } from "./pages/Datenschutz";
import { AGB } from "./pages/AGB";
import { Impressum } from "./pages/Impressum";
import { Experience } from "./pages/Experience";
import { Reservation } from "./pages/Reservation";
import { useEffect } from "react";

// Root'a gelince Home sayfasını göster
const RootRedirect = () => {
  return <Home />;
};

function AppContent() {
  const location = useLocation();
  const isExperiencePage = location.pathname === '/experience';

  // Experience sayfası için Header/Footer olmadan render
  if (isExperiencePage) {
    return (
      <div className="App min-h-screen">
        <Routes>
          <Route path="/experience" element={<Experience />} />
        </Routes>
      </div>
    );
  }

  return (
    <div className="App min-h-screen bg-stone-900">
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          {/* Ana sayfa - "/" */}
          <Route path="/" element={<Home />} />
          
          {/* German routes */}
          <Route path="/startseite" element={<Navigate to="/" replace />} />
          <Route path="/sour" element={<Sour />} />
          <Route path="/sweet" element={<Sweet />} />
          <Route path="/galerie" element={<Gallery />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/impressum" element={<Impressum />} />
          
          {/* Reservation route */}
          <Route path="/reservierung" element={<Reservation />} />
          <Route path="/reservation" element={<Reservation />} />
          
          {/* Redirect old contact routes to reservation */}
          <Route path="/kontakt" element={<Navigate to="/reservierung" replace />} />
          <Route path="/contact" element={<Navigate to="/reservation" replace />} />
          
          {/* English routes */}
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/privacy" element={<Datenschutz />} />
          <Route path="/terms" element={<AGB />} />
          <Route path="/imprint" element={<Impressum />} />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
